import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { debounceAsync } from '@bg-shared/utils/debounceAsync';
import {
    IBettingLimitsResponse,
    IBettingLimitsParams,
    IBettingLimitsResponseFormatted,
} from './interfaces';
import { bettingLimitsFormatter } from './BettingLimits.formatter';

export default class BettingLimitsApi {
    private readonly LIMITS_DEBOUNCE_TIMEOUT = 300;

    public getLimits(params: IBettingLimitsParams): Promise<IBettingLimitsResponseFormatted> {
        const payload = bettingLimitsFormatter.formatPayload(params);

        return httpClientRepository
            .post<IBettingLimitsResponse>(API_URLS.BETTING_LIMITS, {
                data: payload,
            })
            .then((response) => bettingLimitsFormatter.formatResponse(params.options, response))
            .catch(() => bettingLimitsFormatter.defaultValidation);
    }

    public getLimitsWithDebounce = debounceAsync<
        IBettingLimitsResponseFormatted,
        IBettingLimitsParams
    >((params) => {
        return this.getLimits(params);
    }, this.LIMITS_DEBOUNCE_TIMEOUT);
}

export const bettingLimitsApi = new BettingLimitsApi();
